<template>
  <VPopup
    class="transport-order-status-popup"
    closable
    show-pointer
    position="bottom"
    padding="0px"

    :visible="true"
    :target="target"
  >
    <div class="columns">
      <!-- Таможня: дедлайн этапа и статус -->
      <section class="form-section">
        <VDateInput
          v-model="localTransportOrder.deadline"
          label="Дедлайн"
          layout="vertical"
          clearable
        />

        <VSelectV2
          v-model="localTransportOrder.borderStatus"
          label="Таможня"
          layout="vertical"
          :data="TransportOrder.borderStatuses"
        />
      </section>

      <!-- Комментарий — отдельным блоком в первой колонке, под таможней -->
      <section class="form-section">
        <VTextarea
          v-model="localTransportOrder.comment"
          label="Комментарий"
          layout="vertical"
        />
      </section>

      <!-- Обычный статус: согласование и фактические даты -->
      <section class="form-section">

        <header></header>

        <VSwitch
          v-model="localTransportOrder.isConfirmed"
          checked-label="Согласовано"
          unchecked-label="Не согласовано"
          theme="slider"
        />

        <VDateInput
          v-model="localTransportOrder.pickupDateActual"
          label="Забор факт"
          layout="vertical"
          clearable
        >
          <template #helper-text>
            Забор план: {{ $core.utils.date.format(localTransportOrder.pickupDatePlanned) || '--' }}
          </template>
        </VDateInput>

        <VDateInput
          v-model="localTransportOrder.arrivalDateActual"
          label="Прибытие факт"
          layout="vertical"
          clearable
        >
          <template #helper-text>
            Прибытие план: {{ $core.utils.date.format(localTransportOrder.arrivalDatePlanned) || '--' }}
          </template>
        </VDateInput>
      </section>
    </div>

    <footer>
      <VButton theme="primary" @click="submit">
        Сохранить
      </VButton>

      <VButton @click="$core.dialogs.TransportOrderStatusPopup.hide()">
        Отмена
      </VButton>
    </footer>
  </VPopup>
</template>

<style lang="scss">
.transport-order-status-popup {
  width: 640px;

  .columns {
    display: grid;
    grid-template-columns: 1fr 1fr;

    /** Таможня — верх левой колонки */
    > .form-section:nth-child(1) {
      grid-column: 1;
      grid-row:    1;
    }

    /** Комментарий — под таможней. Верхнюю рамку снимает общее правило
     *  .form-section + .form-section, так и задумано. */
    > .form-section:nth-child(2) {
      grid-column: 1;
      grid-row:    2;
    }

    /** Правая колонка — одна секция на высоту обеих секций левой.
     *  Общее правило снимает ей верхнюю рамку — возвращаем, а левую убираем,
     *  чтобы граница между колонками не двоилась. */
    > .form-section:nth-child(3) {
      grid-column: 2;
      grid-row:    1 / span 2;
      border-top:  1px solid var(--faint-strong);
      border-left: none;
    }
  }

  /** Сохранить — слева, Отмена — в противоположном углу */
  > footer {
    display:         flex;
    justify-content: space-between;
    padding:         16px 20px;
    border:          1px solid var(--faint-strong);
    border-top:      none;
  }
}
</style>

<script lang="ts">

import TransportOrder         from '@/domains/TransportOrders/TransportOrder';
import TransportOrdersService from '@/domains/TransportOrders/TransportOrdersService';

export default defineComponent({
  name: 'TransportOrderStatusPopup',

  props: {
    transportOrder: {
      type:     Object as PropType<TransportOrder>,
      required: true,
    },
    /** Ячейка реестра. Из контекстного меню не приходит — попап встаёт на место меню */
    target: {
      type:    Object as PropType<HTMLElement | null>,
      default: null,
    },
  },

  setup() {
    return {
      TransportOrder,
    };
  },

  data() {
    return {
      /** Правим копию — строка реестра не меняется, пока не сохранили */
      localTransportOrder: this.$core.utils.cloneDeep(this.transportOrder) as TransportOrder,
    };
  },

  methods: {
    /** Сохраняет ЗТК и закрывает попап с resolve — по нему вызывающий обновляет реестр */
    async submit(): Promise<void> {
      const success = await TransportOrdersService.update(this.localTransportOrder);

      if (success === true) {
        this.$core.dialogs.TransportOrderStatusPopup.resolve();
      }
      else {
        // ошибку показал сервис — попап оставляем открытым, правки не теряются
      }
    },
  },
});
</script>